import Swiper from "swiper";

class RecommendSlider {
    protected swiper;

    constructor(protected container: HTMLElement) {
        this.swiper = new Swiper(this.container, {
            slidesPerView: 'auto',
            spaceBetween: 15,
            freeMode: false,
        });
    }
}

export default RecommendSlider;
